import React from 'react';
import { OpenInNew } from '@material-ui/icons';

export interface ClassroomResourceLinkProps {
  resource: {
    alternateLink?: string
  }
}

const ClassroomResourceLink = (props: ClassroomResourceLinkProps) => {
  const { resource } = props;

  if (!resource.alternateLink)
    return <span/>;

  return (
    <a href={resource.alternateLink}
       target="_blank"
       rel="noreferrer"
       title="Open in google classroom"
    >
      <OpenInNew fontSize="small" />
    </a>
  );
};

export default ClassroomResourceLink;
